/* Voorraadmelding: werkt het bericht bij zodra een andere variant gekozen wordt. */
(function () {
  /* Mobiel: de Klaviyo-teaser (10% korting) ligt anders over de bestelknop op de productpagina, dus daar niet tonen. */
  if (!document.getElementById('nk-teaser-fix')) {
    var st = document.createElement('style');
    st.id = 'nk-teaser-fix';
    st.textContent = '@media (max-width: 749px){ body.template-product [class*="kl-teaser"]{ display: none !important; } }';
    document.head.appendChild(st);
  }
  if (window.__nkRestockInit) return;
  window.__nkRestockInit = true;
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
    var d = evt && evt.data;
    if (!d || !d.html) return;
    var src = d.html.getElementById('NKRestock-' + d.sectionId);
    var dst = document.getElementById('NKRestock-' + d.sectionId) || document.querySelector('[id^="NKRestock-"]');
    if (!src || !dst) return;
    dst.innerHTML = src.innerHTML;
    dst.hidden = src.hasAttribute('hidden');
  });
})();
